//  style components
// images
import ImagenBannner from "../../../assets/landing/paneldegestion.jpg";
export const BannerPanel = () => {
return (
<div className="row">
   <img src={ImagenBannner} style={{maxWidth: '100%', position: 'relative'}} alt="inversion comunas"></img>
</div>
);
};

